import {makeObservable, observable, action} from 'mobx';

import {logErrorToSentry} from "../../utils/errors/logErrorToSentry";
import {IGraphQLSubscriptionClient} from "../gqlModel/IGraphQLSubscriptionClient";


export abstract class ActiveRecord<T extends any = any, D = T> {
    isInitialized: boolean = false;
    row?: D;
    _isDestroyed: boolean = false;
    _wsClient?: IGraphQLSubscriptionClient;
    abstract readonly _modelName: string;
    abstract readonly _subscriptionGQL?: string;

    constructor() {
        makeObservable(this, {
            isInitialized: observable,
            setIsInitialized: action,

            row: observable,
            _setRow: action,
        });
    }

    abstract getWsClient(): Promise<IGraphQLSubscriptionClient | undefined>;

    abstract loadGQLFetch(): Promise<T>;


    setIsInitialized(isInitialized: boolean) {
        this.isInitialized = isInitialized;
    }

    async initialLoad() {
        try {
            const result = await this.loadGQLFetch();
            this._setRow(this.mapServerResponseToLocalRow(result));
            if (result) {
                this.setIsInitialized(true);
                this._initSync();
            }
        } catch (error: any) {
            logErrorToSentry(error);
        }
    }
    /*=========================================== inner implementation =============================================*/

    /*------------- sync logic ---------------*/
    async _initSync() {
        if (!this._subscriptionGQL) {
            return;
        }
        this._wsClient = await this.getWsClient();
        if (this._wsClient && !this._isDestroyed) {
            this._wsClient.registerSubscription(`onUpdate${this._modelName}`, this._subscriptionGQL, this._onUpdate);
        }
    }

    _onUpdate = (updatedItem: T) => {
        if (!updatedItem) {
            return;
        }
        this._setRow(this.mapServerResponseToLocalRow(updatedItem));
    }


    mapServerResponseToLocalRow(row: T) {
        return row as unknown as D;
    }
    /*----------- sync logic end -------------*/

    _setRow(row: D) {
        this.row = row;
    }

    destroy() {
        this._isDestroyed = true;
        if (this._wsClient) {
            this._wsClient.cancelSubscription(`onUpdate${this._modelName}`);
        }
    }
}
